var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"5ebb10e149d18c006620553541f6d098214eb66c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["client2@goldfinch"]={id:"5ebb10e149d18c006620553541f6d098214eb66c"};
      